const OPEN_GROUPS_KEY = "oko.adminNav.openGroups";

export const readOpenGroups = () => {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(OPEN_GROUPS_KEY));
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};

export const writeOpenGroups = (groupIds) => {
  try {
    window.localStorage.setItem(OPEN_GROUPS_KEY, JSON.stringify(groupIds));
  } catch {
    // Storage blocked (e.g. privacy mode): the open set lives for this page only.
  }
};
